import { render, staticRenderFns } from "./CourseContentSection.vue?vue&type=template&id=b3e50686&scoped=true&"
import script from "./CourseContentSection.vue?vue&type=script&lang=js&"
export * from "./CourseContentSection.vue?vue&type=script&lang=js&"
import style0 from "./CourseContentSection.vue?vue&type=style&index=0&id=b3e50686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e50686",
  null
  
)

export default component.exports